import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QueryKey } from '@/Config/api/queryKey';
import { ActionDto } from '@/Domain/api/Action/dto/Action.dto';
import { ActionTypeEnum } from '@/Domain/enum/ActionType.enum';
import { useActionLimit } from '@/Domain/hooks/Action/useActionLimit.hook';

/** Duplicate one AI Action onto the same agent. The copy lands inactive. */
export const useDuplicateAction = () => {
  const queryClient = useQueryClient();
  const { createLimit } = useActionLimit();

  const { mutate, isPending } = useMutation<ActionDto, unknown, number>({
    mutationKey: [QueryKey.actions.basic.duplicate],
  });

  const actions = queryClient.getQueryData<ActionDto[]>([QueryKey.actions.basic.list]);
  // Knowledge Base actions are exempt from the cap server-side (is_ai_action_limit_reached).
  const cappedActionCount = (actions ?? []).filter(
    (action) => action.type !== ActionTypeEnum.KnowledgeBase,
  ).length;
  const canDuplicate = cappedActionCount < createLimit;

  return {
    duplicateAction: (actionId: number) => mutate(actionId),
    isDuplicating: isPending,
    canDuplicate,
  };
};
